module.exports = __webpack_public_path__ + "static/img/crm914.c84f90e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/crm914.jpg
// module id = iln8
// module chunks = 73